import { Box, Container, Tab, Typography } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import TabContext from "@mui/lab/TabContext";
import { TabList, TabPanel } from "@mui/lab";
import Overview from "../../components/Transaction/Overview";
import Consensus from "../../components/Transaction/Logs";
import Mev from "../../components/Transaction/Stat";
// import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
// import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { useParams } from "react-router-dom";
import { useUpcxChain } from "../../hook/useUpcxChain";
import { GetTransactionResult } from "upcx-js/dist/upcxjs-rpc-interfaces";
import { Transaction, TransactionsService } from "../../backend";

const TxDetail = () => {
  const { jsonRpc, selectedShard } = useUpcxChain();
  const [value, setValue] = React.useState("1");
  const [transaction, setTransaction] = useState<GetTransactionResult>();
  const [txSyncData, setTxSyncData] = useState<Transaction>();
  const { id } = useParams();

  const blockNum = useMemo(() => txSyncData?.blockNum, [txSyncData]);

  const getTxSyncData = async () => {
    if (!id) return;
    const result = await TransactionsService.getTransactionsById(id);
    setTxSyncData(result);
  };

  useEffect(() => {
    if (!selectedShard) {
      return;
    }

    getTxSyncData();
    //eslint-disable-next-line
  }, [id, selectedShard]);

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  const getTransaction = async () => {
    if (!id || !jsonRpc || !blockNum) return;
    const result = await jsonRpc.history_get_transaction(id, blockNum);
    setTransaction(result);
  };

  useEffect(() => {
    getTransaction();
    // eslint-disable-next-line
  }, [id, jsonRpc, blockNum]);

  return (
    <>
      <Container className="container-xxl">
        <Box className="d-flex flex-wrap justify-content-between align-items-center border-bottom gap-3 py-5">
          <Box className="d-flex flex-column gap-1">
            <Box className="d-flex flex-wrap align-items-center gap-1">
              <Typography className="h5 me-1 mb-0">
                Transaction Details
              </Typography>
              {/* <Box className="text-nowrap d-flex gap-1">
                <Link
                  className="btn btn-sm btn-secondary py-0.5"
                  href="/block/19019966"
                  data-bs-toggle="tooltip"
                  data-bs-trigger="hover"
                  data-bs-placement="top"
                  aria-label="View previous block"
                >
                  <ChevronLeftIcon fontSize="small" className="text-icon" />
                </Link>
                <Link
                  className="btn btn-sm btn-secondary py-0.5"
                  href="/block/19019966"
                  data-bs-toggle="tooltip"
                  data-bs-trigger="hover"
                  data-bs-placement="top"
                  aria-label="View previous block"
                >
                  <ChevronRightIcon fontSize="small" className="text-icon" />
                </Link>
              </Box> */}
            </Box>
          </Box>
        </Box>
      </Container>

      <Container className="container-xxl pt-2 pb-12">
        <Box sx={{ width: "100%", typography: "body1" }}>
          <TabContext value={value}>
            <Box className="py-3">
              <TabList
                onChange={handleChange}
                aria-label="Block Info Tab"
                className="normal-tab-group"
                indicatorColor="primary"
                textColor="inherit"
              >
                <Tab label="Overview" className="normal-tab" value="1" />
                <Tab label="State" className="normal-tab" value="3" />
              </TabList>
            </Box>
            <TabPanel value="1" className="p-0">
              <Overview transaction={transaction} txSyncData={txSyncData} />
            </TabPanel>
            <TabPanel value="2" className="p-0">
              <Consensus />
            </TabPanel>
            <TabPanel value="3" className="p-0">
              <Mev />
            </TabPanel>
          </TabContext>
        </Box>
      </Container>
    </>
  );
};

export default TxDetail;
